import { createSelector } from '@reduxjs/toolkit';
import { ReducerState } from '../../store.types';

export const authSelector = ({ auth }: ReducerState) => auth;
export const authUserSelector = createSelector(authSelector, ({ user }) => user);
export const authAccessTokenSelector = createSelector(authSelector, ({ accessToken }) => accessToken);
